export default __webpack_public_path__ + "static/media/FR_Dress_Edited10.63b6b454.png";